import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../../api';

const SpecialityDropdown = ({ value, onChange, name }) => {
  const [specialities, setSpecialities] = useState([]);

  useEffect(() => {
    axiosInstance.get('/specialities')
      .then((response) => setSpecialities(response.data))
      .catch((error) => console.error('Error fetching specialities:', error));
  }, []);

  return (
    <select
      className="form-control"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="">Select Speciality</option>
      {specialities.map((s) => (
        <option key={s.id} value={s.id}>
          {s.speciality_name}
        </option>
      ))}
    </select>
  );
};

export default SpecialityDropdown;
